import { withDependencies, named } from '@wix/thunderbolt-ioc'
import {
	PageFeatureConfigSymbol,
	BrowserWindowSymbol,
	BrowserWindow,
	Structure,
	IStructureStore,
	CompsLifeCycleSym,
	ICompsLifeCycle,
} from '@wix/thunderbolt-symbols'
import type { ComponentsQaApiPageConfig, ComponentsQaApiHandlers } from '../types'
import { name } from '../symbols'
import { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { setDataCompOnElements } from '../componentsQaApi'

export const ComponentsQaApi = withDependencies(
	[named(PageFeatureConfigSymbol, name), BrowserWindowSymbol, Structure, CompsLifeCycleSym],
	(
		pageConfig: ComponentsQaApiPageConfig,
		window: NonNullable<BrowserWindow>,
		structureStore: IStructureStore,
		compsLifeCycle: ICompsLifeCycle
	): IModelUpdatesHandlersImplementor<ComponentsQaApiHandlers> => {
		return {
			featureName: name,
			handlers: {
				dataCompHandler: async () => {
					await setDataCompOnElements(
						pageConfig.componentsTypes,
						pageConfig.componentNicknames,
						window,
						structureStore,
						compsLifeCycle
					)
				},
			},
		}
	}
)
